module.exports = __webpack_public_path__ + "img/table-car-icon.be78cdc7.svg";